// src/platform/wake-lock.ts
import { isNative } from './platform';

type WakeLockHandle = { release: () => Promise<void> | void };

export async function requestWakeLock(): Promise<WakeLockHandle> {
  if (isNative()) {
    try {
      const { KeepAwake } = await import('@capacitor-community/keep-awake');
      await KeepAwake.keepAwake();
      return { release: () => KeepAwake.allowSleep() };
    } catch {
      return { release: () => {} };
    }
  }

  // Web fallback
  if ('wakeLock' in navigator) {
    try {
      const lock = await (navigator as any).wakeLock.request('screen');
      return { release: () => lock.release() };
    } catch {
      return { release: () => {} };
    }
  }
  return { release: () => {} };
}
